/* eslint-disable no-unreachable */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, lifecycle, branch, renderComponent, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import { getUserProgramsFullRequest, selectUserPrograms, resetUserPrograms } from '../redux/reducers/userProgramsFull';
import { changeRedirectFlag } from '../redux/reducers/userOverallReport';
import { toggleThinkToolPopup, toggleUserDashboard, toggleAddProgrammePopup } from '../redux/reducers/view';
import { announcementsRequest } from '../redux/reducers/announcements';
import Typography from '@material-ui/core/Typography';
import { getTeamMembersFullRequest, selectMessage,resetSelectionMessage } from '../redux/reducers/teamMembersFull';

import Spinner from './Spinner';
import Modal from '@material-ui/core/Modal';
import ProgrammesCard from './Cards/ProgrammesCard';
import { commonStyles, COLORS } from '../styles/styles';
import AlertAnnouncement from '../assets/alertAnnouncement.svg'
import SystemAnnouncement from '../assets/systemAnnouncement.svg'

import { convertTime } from '../utils';
import { updateMessageStatusRequest, messageStatusAction } from '../redux/reducers/message';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import {getCoachesPrograms} from '../redux/selectors'




import AvatarCirce from './AvatarCircle';

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBRow,
  MDBCol,
  MDBIcon} from "mdbreact";
import { addProgramFailure } from '../redux/reducers/addProjectCode';





const CoachProgrammesListSmall = ({
  classes, 
  programs, 
  onProgramClick, 
  showAlert, 
  handleOk, 
  handleAlert, 
  newAnnouncements, 
  handleMessageUpdate,
  showLoader,
  loginReducer,
  toggleActiveTab,
  activeItem,
  toggleAddProgrammePopup
}) => {
  const renderPrograms = () =>
  programs &&
  programs.map(item => (
      <div className="col-md-6 col-lg-3" style={{width:'100%', paddingLeft:5, paddingRight:5}} key={item.programId} onClick={() => onProgramClick(item)} >
         <ProgrammesCard
          type="programCard"
          name={item.name}
          backgroundImg={item.background}
          description={item.description}
          background={item.background}
          rolloutCode={item.rolloutCode}
          startDate={
            item.startDate && item.startDate !== null ? convertTime(item.startDate.date) : ''
          }
          dueDate={item.dueDate && item.dueDate !== null ? convertTime(item.dueDate.date) : ''}
          isSelected={false}
          status={'in progress'}
          pending={item.p_instancePending}
          unread={item.p_unreadCount}
          users={item.users.length}
        />
      </div>
    ));
  return <MDBCard  className="z-depth-2 rounded-0">
      <div className='text-dark text-left pt-3 pl-3'>
            REVIEWABLE PROJECTS
            </div>
     <MDBBtn
            floating
            style={{position: 'absolute', right: 0, top: 0}}
            tag='a'
            className='ml-auto ml-4 '
            action
            onClick={()=>toggleAddProgrammePopup(true)}
          >
            <MDBIcon icon='plus' className="success-color" size="md"/>
          </MDBBtn>
          <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
      <div className="contentScrollMod">
        <MDBRow style={{width:'100%', margin: '0 auto'}}>{renderPrograms()}</MDBRow>
      </div>
    
    
  </MDBCard>
  
  {showAlert && <Dialog
        open={showAlert}
        onClose={handleAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{paper:classes.dialogPaper}}
      >
      <div style={{backgroundColor:'white', padding:8}}>
        <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
          {"Hi "+loginReducer.user.firstName}
          <h5 className={classes.dialogSub}>Please click on each notification to accept
and enter the platform</h5></DialogTitle>
        <DialogContent className={classes.dialogContent}>
        {
          newAnnouncements.map(
            content => {
              switch (content.type) {
                case 'site':
                  return <div className={classes.dialogYellowBg}>
                  <div className={classes.dialogIconBg}>
                    <img src={SystemAnnouncement} alt="addCodeImage" className={classes.image} />
                 </div> 
                 <Typography component="p" className={classes.dialogCopy}>
                   {content.message}
                 </Typography>
                 <DialogActions className={classes.dialogActions}>
                   <Button className={classes.dialogBtn} onClick={()=>  handleMessageUpdate(content.messageId)} color="primary">
                     ACCEPT
                   </Button>
                   {/* <Button className={classes.doneBtn} onClick={()=>  handleOk()} color="primary">
                     X
                   </Button> */}
                 </DialogActions>
                 <div className={classes.clearBoth}></div>
               </div>
                  break;
              
                default:
                    return <div className={classes.dialogPinkBg}>
                    <div className={classes.dialogIconBg}>
                    <img src={AlertAnnouncement} alt="addCodeImage" className={classes.image} />
                   </div> 
                   <Typography component="p" className={classes.dialogCopy}>
                     {content.message}
                   </Typography>
                   <DialogActions className={classes.dialogActions}>
                     <Button className={classes.dialogBtn} onClick={()=>  handleMessageUpdate(content.messageId)} color="primary">
                       ACCEPT
                     </Button>
                     {/* <Button className={classes.doneBtn} onClick={()=>  handleOk()} color="primary">
                       X
                     </Button> */}
                   </DialogActions>
                   <div className={classes.clearBoth}></div>
                 </div>
                  break;
              }
             
              
            }
          )}
        </DialogContent>
        
        
        </div>
        <div className={classes.avatarHolder}>
        <AvatarCirce
                  senderName={loginReducer.user.firstName+' '+loginReducer.user.lastName}
                  bg={COLORS.blackTransparent}
                  withBorder
                  color={COLORS.cornerstoneRed}
                  size={100}
                />
        </div>
        <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={showLoader}
        
      >
        <div >
          <Spinner/>

        </div>
      </Modal>
      </Dialog>};
};

const styles = () => ({
  ...commonStyles,
  menuItem: {
    margin: '-8px 0',
  },
});


const mapStateToProps = state => ({
  view: state.viewReducer,
  loginReducer: state.loginReducer,
  programs: getCoachesPrograms(state),
  userOverallReportReducer: state.userOverallReportReducer,
  announcements: state.announcementsReducer.announcements,
  announcementApi: state.announcementsReducer,
  messageReducer: state.messageReducer,
});

const mapDispatchToProps = dispatch => ({
  getTeamMembersFullRequest: () => dispatch(getTeamMembersFullRequest()),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  toggleThinkToolPopup: value => dispatch(toggleThinkToolPopup(value)),
  changeRedirectFlag: value => dispatch(changeRedirectFlag(value)),
  announcementsRequest: () => dispatch(announcementsRequest()),
  messageStatusAction: value => dispatch(messageStatusAction(value)),
  selectMessage: messageId => dispatch(selectMessage(messageId)),
  resetSelectionMessage: () => dispatch(resetSelectionMessage()),
  updateMessageStatusRequest: value => dispatch(updateMessageStatusRequest(value)),
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  resetUserPrograms: () => dispatch(resetUserPrograms()),
 
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('initialSelectionProgramm', 'handleInitialSelectionProgramm', false),
  withState('showAlert', 'toggleShowAlert', false),
  withState('showLoader', 'toggleShowLoader', false),
  withState('newAnnouncements','setAnnouncements', []),
  withState('activeItem','setActiveItem', '1'),
  withHandlers({
    handleMessageUpdate: props => (messageId) => {
      props.resetSelectionMessage();
      //props.selectMessage(messageId)
      props.messageStatusAction('read');
      props.updateMessageStatusRequest(messageId)
    },
  }),
  withHandlers({
    onProgramClick: props => item => {
      
      props.changeRedirectFlag(false);
      
      props.selectUserPrograms(item.programId);
      props.history.push('/users/'+item.programId+ props.history.location.search);
    
      if (props.view.isUserDashboardOpened) {
        props.toggleUserDashboard(false);
      }
    },
    handleAlert: props => () => {
      const { showAlert } = props;
      props.toggleShowAlert(!showAlert);
    },
    toggleActiveTab: props => (tab) => {
      
      if (props.activeItem !== tab) {
        props.setActiveItem(tab)
      }
    },
   
    handleOk: props => () => {
      // const { showAlert } = props;
      // for (let index = 0; index < props.newAnnouncements.length; index++) {
      //   const element = props.newAnnouncements[index];
       
      
      //  setTimeout(() => (props.handleMessageUpdate(element.messageId)),index*500)
      // }
      // props.toggleShowAlert(!showAlert);
    }
  }),
  lifecycle({
    componentWillMount() {
      const {  announcementsRequest, resetUserPrograms } = this.props;
      resetUserPrograms();
    },
    componentWillReceiveProps(nextProps) {
     
     
      
      if(nextProps.announcements!=this.props.announcements){
        var ann=[]
        for (let index = 0; index < nextProps.announcements.length; index++) {
          const element = nextProps.announcements[index];
          if(element.status=='new'){
            ann.push(element)
          }
          
        }
        nextProps.setAnnouncements(ann);
        if(ann.length>0){
          nextProps.toggleShowAlert(true);
        }else{
          nextProps.toggleShowAlert(false);
        }
      }
    },
    componentWillUnmount() {
      this.props.toggleThinkToolPopup(false);
    },
  }),
 
  withStyles(styles),
)(CoachProgrammesListSmall);

CoachProgrammesListSmall.propTypes = {
  userProgramsFull: PropTypes.instanceOf(Object),
  onProgramClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/CoachProgrammesListSmall.jsx